import(/* webpackMode: "eager" */ "/codebuild/output/src3437810515/src/pubgen-app/next-app/app/global-error.tsx");
